import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import updateZipFormFromData from 'core/controllers/zipSearchHandler'
import returningUserBar from 'pug/mixins/returningUserBar'

function initDOM({ hcStorage }) {
  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })
  updateZipFormFromData({ hcStorage, autofocus: false })
  returningUserBar(hcStorage)

  executeWhenFinishToRender(hcStorage)
}

export default initDOM
